import React from 'react';
import c from 'classnames';

import { Button, useDialog } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

export interface DialogProps {
  title: string;
  openButtonTitle: string;
  ctaButtonTitle?: string;
  ctaButtonOnClick?: () => void;
  className?: string;
  children: React.ReactNode;
}

// TODO: use DialogComponent.
// See implementation/Paragraph/ChapterMap/Dialog/index.jsx for an example.
const SearchAllContentDialog: React.FC<DialogProps> = (props) => {
  const {
    title,
    openButtonTitle,
    ctaButtonTitle,
    ctaButtonOnClick,
    className,
    children,
  } = props;

  const {
    dialogIsOpen,
    openDialog,
    closeDialog,
  } = useDialog();

  const classNames = c('SearchAllContentDialog', className, {
    'SearchAllContentDialog--is-open': dialogIsOpen,
  });

  return (
    <>
      <Button
        primary={false}
        className="SearchAllContentDialog__open-button Button--secondary "
        onClick={openDialog}
      >
        {openButtonTitle}
      </Button>

      <div className={classNames}>
        <header className="SearchAllContentDialog__header">
          <h2 className="asH3">{title}</h2>
          <Button
            primary={false}
            className="Button--text icon-after icon-cross"
            onClick={closeDialog}
          />
        </header>

        <main className="SearchAllContentDialog__content">
          {children}
        </main>

        {ctaButtonTitle && (
          <footer className="SearchAllContentDialog__footer">
            <Button
              primary
              withThemeColor
              className="SearchAllContentDialog__cta"
              onClick={() => {
                closeDialog();

                if (ctaButtonOnClick) {
                  ctaButtonOnClick();
                }
              }}
            >
              {ctaButtonTitle}
            </Button>
          </footer>
        )}
      </div>
    </>
  );
};

export default SearchAllContentDialog;
